<template>
	<div class="nav-toggle" @click="menuToggle()" :class="{ open: isOpen }">
		<span></span>
		<span></span>
		<span></span>
	</div>
</template>

<script>
export default {
	data() {
		return {
			isOpen: false,
		};
	},
	methods: {
		menuToggle() {
			this.isOpen = !this.isOpen;
			this.$emit('click');
		},
	},
};
</script>

<style lang="scss">
	.nav-toggle {
		width: 20px;
		height: 20px;
		position: fixed;
		right: 20px;
		top: 18px;
		-webkit-transform: rotate(0deg);
		-moz-transform: rotate(0deg);
		-o-transform: rotate(0deg);
		transform: rotate(0deg);
		-webkit-transition: 0.5s ease-in-out;
		-moz-transition: 0.5s ease-in-out;
		-o-transition: 0.5s ease-in-out;
		transition: 0.5s ease-in-out;
		cursor: pointer;
		z-index: 9999;
		background: transparent;
		display: block;

		span {
			display: block;
			position: absolute;
			overflow: hidden;
			height: 3px;
			opacity: 1;
			left: 0;
			right: 0;
			width: 20px;
			-webkit-transform: rotate(0deg);
			-moz-transform: rotate(0deg);
			-o-transform: rotate(0deg);
			transform: rotate(0deg);
			-webkit-transition: 0.25s ease-in-out;
			-moz-transition: 0.25s ease-in-out;
			-o-transition: 0.25s ease-in-out;
			transition: 0.25s ease-in-out;
			background: #fff;

			&:nth-child(1) {
				top: 0px;
				-webkit-transform-origin: left center;
				-moz-transform-origin: left center;
				-o-transform-origin: left center;
				transform-origin: left center;
			}

			&:nth-child(2) {
				top: 7px;
				-webkit-transform-origin: left center;
				-moz-transform-origin: left center;
				-o-transform-origin: left center;
				transform-origin: left center;
				right: 20%;
				width: 70%;
			}

			&:nth-child(3) {
				top: 14px;
				-webkit-transform-origin: left center;
				-moz-transform-origin: left center;
				-o-transform-origin: left center;
				transform-origin: left center;
			}
		}

		&.open span {
			background: #fff;

			&:nth-child(1) {
				-webkit-transform: rotate(45deg);
				-moz-transform: rotate(45deg);
				-o-transform: rotate(45deg);
				transform: rotate(45deg);
				top: 0px;
			}

			&:nth-child(2) {
				width: 0%;
				opacity: 0;
			}

			&:nth-child(3) {
				-webkit-transform: rotate(-45deg);
				-moz-transform: rotate(-45deg);
				-o-transform: rotate(-45deg);
				transform: rotate(-45deg);
				top: 14px;
			}
		}
	}
</style>
